import React, {Component} from 'react';
import PropTypes from 'prop-types';
import { CSSTransition } from 'react-transition-group';
import _ from 'lodash';
import colors from "../../../util/colors";

class FancyInput extends Component {

  static GetNumericKeyValue = (evt) => {
    let keyCode = evt.keyCode || evt.which;
    // Matt's hack to get number pad input
    // https://stackoverflow.com/questions/5630918/get-correct-keycode-for-keypadnumpad-keys
    if (keyCode >= 96 && keyCode <= 105) {
      keyCode -= 48;
    }
    return +String.fromCharCode(keyCode);
  }

  constructor(props){
    super(props)

    this.inputField = React.createRef();

    this.state = {
      isActive: false
    }
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    let previousValue = prevProps.inputValue;
    let curValue = this.props.inputValue;

    if(previousValue !== curValue){
      if(!curValue || curValue.length === 0){
        this.setState({isActive: false})
      }
      else{
        this.setState({isActive: true})
      }
    }
  }

  componentDidMount(){
    let { inputValue } = this.props;

    if(!inputValue || inputValue.length === 0){
      this.setState({isActive: false})
    }
    else{
      this.setState({isActive: true})
    }

    if(this.props.onRef) {
      this.props.onRef(this)
    }
  }

  componentWillUnmount(){
    if(this.props.onRef) {
      this.props.onRef(undefined);
    }

    if(this.timer){
      clearTimeout(this.timer);
    }
  }

  focus(){
    this.inputField.current.focus();
  }

  blur(){
    this.inputField.current.blur();
  }

  selectAllText(){
    this.inputField.current.select();
  }

  onInputFocus(evt){
    let { onFocus } = this.props;

    this.setState({isActive: true});

    if(onFocus){
      onFocus(evt);
    }
  }

  onInputBlur(){
    let { inputValue } = this.props;

    if(!inputValue || inputValue.length === 0){
      this.setState({isActive: false})
    }
  }

  onKeyDown(evt){
    let { onDelete } = this.props;

    if(onDelete && evt.key === 'Backspace'){
      onDelete();
    }
  }

  onKeyUp(evt){
    let { onEnter, inputNumeric, onKeyPress } = this.props;

    if(onEnter && evt.key === 'Enter'){
      onEnter();
    }
    else if(inputNumeric){
      let keyValue = FancyInput.GetNumericKeyValue(evt);
      if(_.isNaN(keyValue) || keyValue < 0 || keyValue > 9){
        evt.preventDefault();
      }
    }

    if(onKeyPress){
      onKeyPress(evt);
    }
  }

  onPaste(evt){
    let { onPaste } = this.props;

    if(onPaste){
      onPaste(evt);
    }
  }

  onInputChange(evt){
    let { onChange } = this.props;

    if(onChange && evt.target) {
      onChange(evt.target.value);
    }
  }

  onInfoClick(evt){
    let { onInfoClick } = this.props;

    onInfoClick();
  }

  triggerValidationErr(){
    var me = this;

    me.setState({
      showShake: true,
    }, () => {
      this.timer = setTimeout(() => {
        me.setState({
          showShake: false
        })
      }, 400) //same as the animation time
    })
  }

  onInputClick(evt){
    if(this.props.onInputClick){
      this.props.onInputClick(evt);
    }
  }

  render(){
    let {
      placeholder,
      inputDisabled,
      inputReadonly,
      fieldType,
      inputValue,
      isValid,
      infoBtnCls,
      inputCls,
      maxInputLength,
      inputPattern,
      hideInfoBtn,
      useDisabledStyles
    } = this.props;

    let {
      isActive,
      showShake
    } = this.state;

    let wrapStyle = {
      position: 'relative',
      overflow: 'initial',
      WebkitTransition: 'all .25s ease-in',
      transition: 'all .25s ease-in',
      borderRadius : '4px'
    }

    if(!inputDisabled){
      wrapStyle.border = '1px solid #fff';
    }
    else{
      wrapStyle.border = '1px solid transparent';
    }

    if(showShake){
      wrapStyle.animation = 'shake 400ms ease-in-out';
    }

    let labelStyle = {
      pointerEvents: 'none',
      position: 'absolute',
      left: '0px',
      top: '-2px',
      fontSize: '14px',
      margin: '10px',
      padding: '0 3px',
      backgroundColor: 'transparent',
      WebkitTransition: 'all .25s ease-in',
      transition: 'all .25s ease-in'
    }

    if(inputDisabled){
      labelStyle.color = 'transparent'
    }
    else{
      labelStyle.color = '#fff'
    }

    if(isActive || inputValue.length > 0){
      labelStyle = {
        ...labelStyle,
        top: '-30px',
        fontSize: '12px',
        backgroundColor: 'transparent'
      }
    }

    let inputStyle = {
      color: '#fff',
      backgroundColor: 'transparent',
      borderColor: 'transparent',
      textShadow: '0px 0px 0px #fff',
      WebkitTextFillColor: 'transparent',
      WebkitTransition: 'all .25s ease-in',
      transition: 'all .25s ease-in'
    }

    if(isActive){
      inputStyle.color = colors.PRIMARY_DARK_TEXT;
      inputStyle.WebkitTextFillColor = colors.PRIMARY_DARK_TEXT;

      wrapStyle.backgroundColor = '#fff';
    }

    if(useDisabledStyles) {
      if (inputDisabled || inputReadonly) {
        inputStyle.backgroundColor = colors.DISABLED_AUTH_INPUT;
        inputStyle.borderColor = colors.DISABLED_AUTH_INPUT;
        wrapStyle.backgroundColor = colors.DISABLED_AUTH_INPUT;
        wrapStyle.border = `1px solid ${colors.DISABLED_AUTH_INPUT}`;
      }
    }

    let inputProps = {};
    if(maxInputLength){
      inputProps.maxLength = maxInputLength;
    }
    if(inputPattern){
      inputProps.pattern = inputPattern;
    }

    return (
      <div style={wrapStyle} onClick={(e) => this.onInputClick(e)}>
        {placeholder && <label style={labelStyle}>{placeholder}</label>}
        <div className={'input-group'}>
          <input formNoValidate
                 ref={this.inputField}
                 className={`${inputCls || ''} fancy-input form-control ${isValid ? 'is-invalid' : ''} ${(inputDisabled || inputReadonly) ? 'no-pointer' : ''}`}
                 style={inputStyle}
                 autoComplete={(this.props.autoComplete || 'on')}
                 type={fieldType}
                 disabled={(inputDisabled || inputReadonly)}
                 value={inputValue}
                 onPaste={this.onPaste.bind(this)}
                 onKeyDown={this.onKeyDown.bind(this)}
                 onKeyUp={this.onKeyUp.bind(this)}
                 onChange={this.onInputChange.bind(this)}
                 onBlur={this.onInputBlur.bind(this)}
                 onFocus={this.onInputFocus.bind(this)}
                 {...inputProps}/>
          <CSSTransition in={!hideInfoBtn && infoBtnCls && !inputDisabled}
                         unmountOnExit
                         timeout={400}
                         classNames={'fade'}>
            <div className="input-group-append">
              <i className={`${infoBtnCls} ${isActive ? 'primary-color' : ''} ${!isActive ? 'light-color' : ''}`}
                 style={{paddingLeft: '5px', paddingRight: '5px'}}
                 onClick={this.onInfoClick.bind(this)}/>
            </div>
          </CSSTransition>
        </div>
      </div>
    )
  }
}

FancyInput.propTypes = {
  placeholder: PropTypes.string,
  useDisabledStyles : PropTypes.bool,
  inputDisabled: PropTypes.bool.isRequired,
  inputReadonly: PropTypes.bool,
  inputNumeric: PropTypes.bool,
  hideInfoBtn: PropTypes.bool,
  isValid: PropTypes.bool,
  fieldType: PropTypes.string.isRequired,
  inputValue: PropTypes.string.isRequired,
  inputCls: PropTypes.string,
  inputPattern: PropTypes.string,
  onChange: PropTypes.func,
  onEnter: PropTypes.func,
  onDelete: PropTypes.func,
  onRef: PropTypes.func,
  onFocus: PropTypes.func,
  onKeyPress: PropTypes.func,
  onPaste: PropTypes.func,
  onInputClick: PropTypes.func,
  infoBtnCls: PropTypes.string,
  onInfoClick: PropTypes.func,
  maxInputLength: PropTypes.number,
  autoComplete: PropTypes.string
}

export default FancyInput;
